import { UnavailableReceiptView, ReceiptLineItems } from './components';

export const Receipt = {
  UnavailableView: UnavailableReceiptView,
  LineItems: ReceiptLineItems,
};

export { useReceiptQuery } from './GraphQL/Receipt.generated';
export type { ReceiptQuery } from './GraphQL/Receipt.generated';
